import { render, staticRenderFns } from "./ReturnPolicySection.vue?vue&type=template&id=0e29327b&scoped=true&"
import script from "./ReturnPolicySection.vue?vue&type=script&lang=js&"
export * from "./ReturnPolicySection.vue?vue&type=script&lang=js&"
import style0 from "./ReturnPolicySection.vue?vue&type=style&index=0&id=0e29327b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e29327b",
  null
  
)

export default component.exports